import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AddAsectionsLayer } from "../components/SECTION A/AddAsectionsLayer";

export const AddAsectionsPage = () => {
  return (
    <MasterLayout>
      <AddAsectionsLayer />
    </MasterLayout>
  );
};
